import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Link, Column, Columns } from "@aviary";
import { useInitialProps } from "@unauthenticated/catalog/context";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import * as styles from "../Footer.styles";

const FooterBottomLinks: FC = () => {
  const { t } = useTranslation();
  const { fullscriptCountry } = useInitialProps();

  return (
    <Column columnWidth={6}>
      <Columns>
        <Column columnWidth={4} css={styles.columnBottom}>
          <ul css={styles.linksListBottom}>
            <li>
              <Link
                isColor="system"
                noExternalIcon
                isUnderLined={false}
                href={openCatalogRoutes.privacy}
              >
                {t(l.navigation.PrivacyStatement)}
              </Link>
            </li>
            <li>
              <Link
                isColor="system"
                noExternalIcon
                isUnderLined={false}
                href={openCatalogRoutes.customerSupportPolicy}
              >
                {t(l.navigation.CustomerSupportPolicy)}
              </Link>
            </li>
          </ul>
        </Column>
        <Column columnWidth={4} css={styles.columnBottom}>
          <ul css={styles.linksListBottom}>
            <li>
              <Link
                isColor="system"
                noExternalIcon
                isUnderLined={false}
                href={openCatalogRoutes.termsOfService}
              >
                {t(l.navigation.TermsOfService)}
              </Link>
            </li>
            <li>
              <Link
                isColor="system"
                noExternalIcon
                isUnderLined={false}
                href={openCatalogRoutes.acceptableUsePolicy}
              >
                {t(l.navigation.AcceptableUsePolicy)}
              </Link>
            </li>
          </ul>
        </Column>
        <Column columnWidth={4} css={styles.columnBottom}>
          <ul css={styles.linksListBottom}>
            <li>
              <Link
                isColor="system"
                noExternalIcon
                isUnderLined={false}
                href={openCatalogRoutes.accessibilityPolicy}
              >
                {t(l.navigation.AccessibilityPolicy)}
              </Link>
            </li>
            {fullscriptCountry === "US" && (
              <li>
                <Link
                  isColor="system"
                  noExternalIcon
                  isUnderLined={false}
                  href={openCatalogRoutes.caliPrivacyNotice}
                >
                  {t(l.navigation.CaliPrivacyNotice)}
                </Link>
              </li>
            )}
          </ul>
        </Column>
      </Columns>
    </Column>
  );
};

export { FooterBottomLinks };
